<template>
  <div class="modal-disclaimer">
    <div :class="{ 'collapsed': isSnippet }" ref="disclaimerRef">
      <p>
        <span>The phone and/or email you provide here will replace the previously provided information.</span>
      </p>
      <p>
        By selecting the "Send" button below you agree to receive a confirmation notification. Message
        and data rates may apply.
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick } from 'vue';

const isSnippet = ref(false);

const disclaimerRef = ref(null);

const emit = defineEmits(['doDisclaimer']);

// eslint-disable-next-line no-unused-vars
const toggleDisclaimer = async () => {
  isSnippet.value = !isSnippet.value;
  await nextTick(); 
  if (disclaimerRef.value) {
    const cls = disclaimerRef.value.classList;
    if (!cls.contains('collapsed')) {
      cls.add('expanded');
    }
  }

  emit('doDisclaimer', isSnippet.value);
};
</script>


<style lang="scss" scoped>
.modal-disclaimer {
  --whitespace: calc(var(--padding-horizontal) * 0.5);
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 var(--whitespace) 0;
  margin: 0.5em calc(var(--whitespace) * -1) 1em calc(var(--whitespace) * -1);
  button.toggle {
    margin: 0 0 0 0.05em;
    padding: 0 0.5em 0.5em;
    min-width: var(--icon-dimension);
    height: min-content;
    img {
      width: 16px;
    }
  }
  p {
    color: var(--ri-blue);
    font-size: 0.9rem;
    padding: 0.1em 0 1em;
    @extend %font-sans-semibold;
    span:nth-child(2) {
      &::before {
        content: ' ';
      }
    }
  }
  .collapsed {
    height: 63px;
    overflow: hidden;
    p:first-child {
      span {
        &:first-child {
          &::after {
            content: '..';
          }
        }
        &:nth-child(2) {
          visibility: hidden;
        }
      }
    }
  }
  .expanded {
    animation: fadeIn;
    animation-duration: 2s;
    height: max-content;
  }
}
</style>
